/* RESPONSIBLE TEAM: team-workflows */
export const TEAMMATE_APP_URL = document.querySelector("meta[name='teammate_app_url']")?.content;
